var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 .75c.415 0 .75.336.75.75v2.25h3c.415 0 .75.336.75.75s-.335.75-.75.75H15v9c0 1.24-1.01 2.25-2.25 2.25H6c-1.24 0-2.25-1.01-2.25-2.25v-9H3c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h3V1.5c0-.414.335-.75.75-.75zm1.5 4.5H5.25v9c0 .413.336.75.75.75h6.75c.414 0 .75-.337.75-.75v-9zm-6 1.5c.415 0 .75.336.75.75v5.25c0 .414-.335.75-.75.75s-.75-.336-.75-.75V7.5c0-.414.335-.75.75-.75zm3.75 0c.415 0 .75.336.75.75v5.25c0 .414-.335.75-.75.75s-.75-.336-.75-.75V7.5c0-.414.335-.75.75-.75zm0-4.5H7.5v1.5h3.75v-1.5z",
    transform: "translate(-1269.000000, -345.000000) translate(1040.000000, 0.000000) translate(220.000000, 336.000000) translate(9.000000, 9.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrash);
export default __webpack_public_path__ + "static/media/icon-trash.8e2f6955ad51023f8c947a059c64c5df.svg";
export { ForwardRef as ReactComponent };